import styled from "styled-components";

export const FestivalInterviewWrapper = styled.div`
  width: 100%;
  padding-bottom: 100px;
`;
